import React, { FunctionComponent } from 'react';
import { Page } from '../../components/Page';

export const PetParents: FunctionComponent = () => {
  return <Page title="Pet Parents"></Page>;
};
